module.exports = __webpack_public_path__ + "static/media/08.75234d03.jpg";